<template>
  <div class="carousel">
    <bubble-text
      class="dark-blue no-cursor"
      extUrl="https://www.pepsicobeveragefacts.com/home/find#/filterset/category=1010&page=compare"
    >
      <h2 id="meet15">meet all our flavors</h2>
      <span class="screen-reader-only"> opens in a new tab</span>
    </bubble-text>
    <div
      class="carousel-overlay"
      v-bind:class="{ open: modalOpen }"
      v-on:click="closeModal"
    >
      <div
        class="carousel-modal"
        v-on:click="stopPropagation"
        v-bind:class="{ fadeIn: modalOpen }"
      >
        <div class="carousel-modal--close" v-on:click="closeModal">
          <icon name="times" v-on:click="closeModal"></icon>
        </div>
        <p>Buy Now</p>
        <!-- <a href="https://www.amazon.com/bubly?&_encoding=UTF8&tag=bubly-20&linkCode=ur2&linkId=49fda9d865677967d7e6bed71c193cbc&camp=1789&creative=9325" target="blank"><img src="./../assets/amazon.png" alt="Buy on Amazon" /></a>
        <a href="https://www.kroger.com/pl/all/00?brandName=bubly&query=bubly&searchType=default_search&facets=true" target="blank"><img src="./../assets/kroger.png" alt="Buy on Kroger.com" /></a>
        <a href="https://www.target.com/b/bubly/-/N-y8trn" target="blank"><img src="./../assets/target.jpg" alt="Buy on Target.com" /></a>
        <a href="https://www.walmart.com/col/bubly-Sparkling-Water-Collection/47226939" target="blank"><img src="./../assets/walmart.png" alt="Buy on Walmart.com" /></a> -->
      </div>
    </div>

    <div class="carousel-slider">
      <div class="carousel-controls" ref="NavArrows">
        <div class="prev" @click="Prev" aria-label="previous slide button" role="button" tabindex="0"></div>
        <div class="next" @click="showNext" aria-label="next slide button" role="button" tabindex="0"></div>
        <button class="play-pause" @click="isPlaying" :class="[settings.autoplay ? 'pause' : 'play']"><span class="screen-reader-only">Play/Pause</span></button>
      </div>
      <VueSlickCarousel
        v-bind="settings"
        ref="tinySlider"
        @afterChange="changeNavArrows"
      >
        <div v-for="(item, index) in items" v-bind:key="index" class="slide">
          <div :class="slideClass(item.flavor)">
            <div class="slide-contents">
              <div class="slide-text">
                <h3 class="slide-title">
                  <span>{{ item.flavor.split("-")[0] }}</span
                  ><br class="brk-line" /><span v-if="item.flavor.includes('-')">{{
                    item.flavor.split("-")[1]
                  }}</span
                  >bubly<span v-if="item.r_ball" class="r-ball">®</span>
                </h3>
                <ul class="slide-tagline">
                  <li>{{ item.tagline1 }}</li>
                  <li>{{ item.tagline2 }}</li>
                </ul>
                <div class="carousel-ctas" >
                  <a 
                  :href="item.productUrl" 
                  target="blank"
                  :tabindex="isActiveSlide(index) ? 0 : -1"
                  >
                    product info
                    <span class="screen-reader-only">{{item.flavor}} bubly</span> 
                    <span class="screen-reader-only"> (link opens in a popup)</span>
                  </a>

                  <a
                    :style="{ display: getInfo }"
                    class="buynow"
                    data-toggle="modal"
                    data-target="#widget-modal"
                    data-destini-container="destinidiv"
                    v-bind:data-destini-association="item.destiniAssociation"
                    v-on:click="triggerModal"
                    :tabindex="isActiveSlide(index) ? 0 : -1"
                  >
                    buy now
                    <span class="screen-reader-only">{{item.flavor}} bubly</span> 
                    <span class="screen-reader-only"> (link opens in a popup)</span>
                  </a>
                </div>
              </div>
              <picture class="slide-image">
                <source
                  :srcset="mobileSrc(item.flavor)"
                  media="(max-width: 767px)"
                />
                <source :srcset="desktopSrc(item.flavor)" />
                <img
                  :srcset="mobileSrc(item.flavor)"
                  :alt="item.flavor + ' bubly'"
                />
              </picture>
            </div>
          </div>
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
/* Slider */
import VueTinySlider from "vue-tiny-slider";
import Icon from "vue-awesome/components/Icon";
import bubbleText from "@/components/bubbleText";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "carousel",
  components: {
    // components: { VueSlickCarousel },
    VueSlickCarousel,
    Icon,
    bubbleText
  },

  mounted() {
    // dom-based workaround for slider bug
    // elements cloned for infinite loop do not bind to component methods
    // https://github.com/viktorlarsson/vue-tiny-slider/issues/16
    var ctas = document.querySelectorAll(".buyCta");
    for (var i = 0; i < ctas.length; i++) {
      ctas[i].addEventListener("click", this.showModal);
    }
    // Ensure accessibility: set tabindex=-1 on focusable elements in aria-hidden slides
    this.$nextTick(() => {
      this.updateAriaHiddenTabindex();
    });
  },
  updated() {
    // Update tabindex when DOM changes (e.g., after carousel slide changes)
    this.$nextTick(() => {
      this.updateAriaHiddenTabindex();
    });
  },

  data() {
    return {
      modalOpen: false,
      currentSlideIndex: 0,
      items: [
        {
          flavor: "lime",
          tagline1: "i feel like i can be",
          tagline2: "open around u",
          productUrl: "http://www.pepsicobeveragefacts.com/Home/Product?formula=F0000008506&form=RTD&size=12",
          destiniAssociation: "00012000171444",
          r_ball: true
        },
        {
          flavor: "blackberry",
          tagline1: "fancy meeting",
          tagline2: "you here",
          productUrl: "http://www.pepsicobeveragefacts.com/Home/product?formula=F0000008651&form=RTD&size=12",
          destiniAssociation: "00012000181191",
          r_ball: true
        },
        {
          flavor: "cherry",
          tagline1: "these sips",
          tagline2: "don't lie",
          productUrl: "http://www.pepsicobeveragefacts.com/Home/Product?formula=F0000008529&form=RTD&size=12",
          destiniAssociation: "00012000171451",
          r_ball: true
        },
        {
          flavor: "grapefruit",
          tagline1: "hold cans ",
          tagline2: "with me",
          productUrl: "http://www.pepsicobeveragefacts.com/Home/Product?formula=F0000008761&form=RTD&size=12",
          destiniAssociation: "00012000171475",
          r_ball: true
        },
        {
          flavor: "strawberry",
          tagline1: "here's to the ",
          tagline2: "next sip",
          productUrl: "http://www.pepsicobeveragefacts.com/Home/Product?formula=F0000008507&form=RTD&size=12",
          destiniAssociation: "00012000171529",
          r_ball: true
        },
        {
          flavor: "raspberry",
          tagline1: "did we just become ",
          tagline2: "besties?",
          productUrl: "http://www.pepsicobeveragefacts.com/Home/product?formula=F0000008654&form=RTD&size=12",
          destiniAssociation: "00012000181177",
          r_ball: true
        },
        {
          flavor: "mango",
          tagline1: "love at first ",
          tagline2: "phssst",
          productUrl: "https://www.pepsicoproductfacts.com/Home/product?formula=F0000008760&form=RTD&size=12",
          destiniAssociation: "00012000171505",
          r_ball: true
        },
        {
          flavor: "pineapple",
          tagline1: "let me be ",
          tagline2: "your wingcan",
          productUrl: "https://www.pepsicoproductfacts.com/Home/product?formula=F0000008917&form=RTD&size=12",
          destiniAssociation: "00012000182907",
          r_ball: true
        },
        {
          flavor: "orange-cream",
          tagline1: "sip me ",
          tagline2: "off my feet",
          productUrl: "https://www.pepsicoproductfacts.com/Home/product?formula=F0000014231&form=RTD&size=12",
          destiniAssociation: "",
          r_ball: true
        },
        {
          flavor: "coconut-pineapple",
          tagline1: "i'll drive you ",
          tagline2: "coconuts",
          productUrl: "https://www.pepsicoproductfacts.com/Home/product?formula=F0000011002&form=RTD&size=12",
          destiniAssociation: "00012000206863",
          r_ball: true
        },
        {
          flavor: "bellini-bliss",
          tagline1: "sun, sand, ",
          tagline2: "can in hand",
          productUrl: "https://www.pepsicoproductfacts.com/Home/product?formula=F0000012960&form=RTD&size=12",
          destiniAssociation: "00012000214301",
          r_ball: true
        },
        {
          flavor: "blueberry-pomegranate",
          tagline1: "crazy ",
          tagline2: "fizzy love",
          productUrl: "https://www.pepsicoproductfacts.com/Home/product?formula=F0000009814&form=RTD&size=12",
          destiniAssociation: "00012000214301",
          r_ball: true
        },
        {
          flavor: "strawberry-sunset",
          tagline1: "suns out, ",
          tagline2: "tabs out",
          productUrl: "https://www.pepsicoproductfacts.com/Home/product?formula=F0000015456&form=RTD&size=12",
          destiniAssociation: "00012000230394",
          r_ball: true
        }
      ],
      settings: {
        dots: false,
        edgeFriction: 0.35,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
      }
    };
  },
  methods: {
    triggerModal: e => {
      const container = e.target.getAttribute("data-destini-container");
      const association = e.target.getAttribute("data-destini-association");
      destini.init(container);
      destini.loadWidget(association);
    },
    showModal(e) {
      e.preventDefault();
      this.modalOpen = true;
    },
    closeModal(e) {
      e.stopPropagation();
      this.modalOpen = false;
    },
    stopPropagation(e) {
      console.log("stop prop");
      //e.stopPropagation();
    },
    slideClass(flavor) {
      return "slide_bg slide_bg--" + flavor;
    },
    mobileSrc(flavor) {
      return require("./../assets/backgrounds/" + flavor + "-m.jpg");
    },
    desktopSrc(flavor) {
      return require("./../assets/cans/can-" + flavor + ".png");
    },
    getInfo(e) {
      const info = this.$refs.tinySlider.getInfo();
      console.log(info);
      return info.isOn ? "inline" : "display:none";
      // console.log("what triggers this")
    },
    isPlaying () {
      const wasAutoplaying = this.settings.autoplay;
      this.settings.autoplay = !this.settings.autoplay;

      // When switching from play -> pause, move focus to the visible slide
      if (wasAutoplaying && !this.settings.autoplay) {
        this.$nextTick(() => {
          this.focusCurrentSlide();
        });
      }
    },
    Prev() {
      this.$refs.tinySlider.prev();
    },
    showNext() {
      this.$refs.tinySlider.next();
    },
    changeNavArrows(e) {
      const bounceIndex = [];
      (bounceIndex.includes(e))? this.$refs.NavArrows.classList.add("bounce") : this.$refs.NavArrows.classList.remove("bounce");
      this.currentSlideIndex = e;
      // Update tabindex after slide change
      this.$nextTick(() => {
        this.updateAriaHiddenTabindex();
      });
    },
    isActiveSlide(index) {
      return this.currentSlideIndex === index;
    },
    focusCurrentSlide() {
      // Find the non-hidden, non-cloned slick slide that matches the currentSlideIndex
      const allSlides = this.$el.querySelectorAll('.slick-slide');
      let activeSlide = null;

      allSlides.forEach((slide) => {
        const isAriaHidden = slide.getAttribute('aria-hidden') === 'true';
        const isCloned = slide.classList.contains('slick-cloned');
        const slideIndex = slide.getAttribute('data-slick-index');
        const index = slideIndex !== null ? parseInt(slideIndex, 10) : null;

        if (!isAriaHidden && !isCloned && index === this.currentSlideIndex && !activeSlide) {
          activeSlide = slide;
        }
      });

      // Fallback: first visible, non-cloned slide if index-matched one isn't found
      if (!activeSlide) {
        activeSlide = Array.from(allSlides).find((slide) => {
          const isAriaHidden = slide.getAttribute('aria-hidden') === 'true';
          const isCloned = slide.classList.contains('slick-cloned');
          return !isAriaHidden && !isCloned;
        }) || null;
      }

      if (!activeSlide) return;

      // Prefer focusing the first CTA/link in the active slide
      const focusTarget = activeSlide.querySelector('.carousel-ctas a, a.buynow');
      if (focusTarget) {
        focusTarget.focus();
        return;
      }

      // As a last resort, make the slide itself focusable and focus it
      activeSlide.setAttribute('tabindex', '-1');
      activeSlide.focus();
    },
    updateAriaHiddenTabindex() {
      // Only set tabindex="-1" on focusable elements in hidden/cloned slides.
      // Vue's :tabindex binding on the template is the single source for tabindex="0" on the active slide.
      const hiddenOrClonedSlides = this.$el.querySelectorAll('.slick-slide[aria-hidden="true"], .slick-slide.slick-cloned');
      hiddenOrClonedSlides.forEach((slide) => {
        const focusableElements = slide.querySelectorAll('.carousel-ctas a, a.buynow');
        focusableElements.forEach((el) => {
          if (!el.closest('.carousel-controls')) el.setAttribute('tabindex', '-1');
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~tiny-slider/src/tiny-slider";
@import "./../variables";

.carousel {
  font-size: 0;
  position: relative;
  overflow: hidden;
}

.carousel-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  background: rgba(0, 0, 0, 0.7);
  align-items: center;
  justify-content: center;

  &.open {
    display: block;
  }
}

.slide.tns-item {
  a {
    display: none;
  }
  &.tns-slide-active {
    a {
      display: inline;
    }
  }
}

.carousel-modal {
  width: 100%;
  max-width: 260px;
  height: auto;
  min-height: 340px;
  background: #fff;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  box-sizing: border-box;
  padding: 90px 50px 30px;
  color: #000;
  opacity: 0;
  margin: 0 auto;
  left: 0;
  right: 0;

  @include breakpoint("tablet") {
    width: 25rem;
    // transform: translate(-50%, -50%);
  }

  &--close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    padding: 10px;
    cursor: pointer;
  }
  a {
    display: block;
    margin: 1.5rem auto;
  }

  p {
    position: absolute;
    top: 11px;
    left: 50%;
    transform: translateX(-50%);
    text-transform: lowercase;
    font-weight: 600;
    font-size: 16px;
  }
}

#meet15 {
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  padding: 0;
  margin-top: 55px;

}

/* make keyframes that tell the start state and the end state of our object */
@-webkit-keyframes fadeIntro {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIntro {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIntro {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fadeIn {
  opacity: 0; /* make things invisible upon start */
  animation: fadeIntro ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 0.4s;
}

.carousel-slider {
  position: relative;
  overflow: hidden;
}

.carousel-controls {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 1600px;
  z-index: 998; // stay below navigation overlay

  div, >button {
    width: 48px;
    height: 48px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
  }

  .prev {
    background-image: url("./../assets/arrow-left.png");
    transition: background-image .3s linear;
    left: 13px;
  }

  .next {
    background-image: url("./../assets/arrow-right.png");
    transition: background-image .3s;
    right: 13px;
  }

  .play-pause {
    position: absolute;
    border: none;
    border-radius: 50%;
    top: 64vw;
    left: 0;
    right: 0;
    margin: 0 auto;
    background-size: 70%;
    background-position: center;

    &.play {
      background-image: url("./../assets/play_arrow.png");
    }

    &.pause {
      background-image: url("./../assets/pause.png");
    }

    @include breakpoint("tablet") {
      top: 271px;
    }
  }

  &.bounce{
      .prev {
      background-image: url("./../assets/arrow-left-bounce.png");
      left: 13px;
    }

    .next {
      background-image: url("./../assets/arrow-right-bounce.png");
      right: 13px;
    }

  }
}

.tns-inner {
  display: none;
}

.carousel-ctas {
  float: left;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;

  a {
    box-sizing: border-box;
    width: calc(50% - 20px);
    margin: 0 10px;
    padding: 5px;
    white-space: nowrap;
    text-align: center;
    border: 2px solid #fff;
    border-radius: 20px;
    display: inline-block;
    font-size: 18px;
    padding: 7px;
    cursor: pointer;

    &:hover {
      background-color: #fff;
    }
  }
}

.slide {
  &_bg {
    position: relative;
    background-position: center bottom;
    background-repeat: repeat-x;

    .brk-line{
      display: none;
    }

    .r-ball {
      color: #fff;
      font-size: 10px;
      @include breakpoint("tablet") {
        color: #fff;
        font-size: 12px;
        text-align: left;
      }
    }

    &--coconut-pineapple {
      background-color: $flavor-coconut-pineapple;
      span {
        color: $flavor-coconut-pineapple-can;

        &:first-child {
          color: $flavor-coconut-pineapple-accent;
        }
      }
      .brk-line {
        display: block;
      }
      @include breakpoint("laptop") {
        .brk-line {
          display: none;
        }
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/coconut-pineapple.png"), linear-gradient(180deg, #00b8c5, #fae100);
        background-repeat: repeat-x, no-repeat;
        background-size: auto 305px, cover;
        background-position: bottom, 50%;
      }
      .carousel-ctas a:hover, .carousel-ctas a:focus {
        color: $flavor-coconut-pineapple;
      }
    }

    &--passionfruit {
      
      background-color: $flavor-passionfruit;
      span {
        color: $flavor-passionfruit-accent;

        &:last-of-type {
          color: $flavor-passionfruit-can;
        }
      }
      @include breakpoint("tablet") {
        .brk-line {
          display: none;
        }
        background-image: url("./../assets/bubbles/passionfruit.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-passionfruit;
      }
    }

    &--triple-berry {
      // background-color: $flavor-bounce-triple-berry;
      color: $bubly-bounce-blue;
      .slide-title{
        color: $flavor-bounce-triple-berry-accent;
        text-shadow:
        -2px -2px 0 #fff,  
         2px -2px 0 #fff,
         -2px 2px 0 #fff,
          2px 2px 0 #fff;
      }
      span {
        &:last-of-type {
          color: $flavor-bounce-triple-berry;
        }
      }
      .slide-tagline {
        color: $bubly-bounce-blue;
      }
      .carousel-ctas {
        a {
          border-color: $bubly-bounce-blue;
          color: $bubly-bounce-blue;
        }
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/triple-berry.png");

        // background-position: center center;
      }
      .carousel-ctas a:hover {
        color: $flavor-bounce-triple-berry;
      }
    }

    &--citrus-cherry {
      // background-color: $flavor-bounce-citrus-cherry;
      color: $bubly-bounce-blue;
      .slide-title{
        color: $flavor-bounce-citrus-cherry-accent;
        text-shadow:
        -2px -2px 0 #fff,  
         2px -2px 0 #fff,
         -2px 2px 0 #fff,
          2px 2px 0 #fff;
      }
      span {
        &:last-of-type {
          color: $flavor-bounce-citrus-cherry;
        }
      }
      .slide-tagline {
        color: $bubly-bounce-blue;
      }
      .carousel-ctas {
        a {
          border-color: $bubly-bounce-blue;
          color: $bubly-bounce-blue;
        }
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/citrus-cherry.png");

        // background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-bounce-citrus-cherry;
      }
    }

    &--mango-passionfruit {
      // background-color: $flavor-bounce-mango-passionfruit;
      color: $bubly-bounce-blue;
      .slide-title{
        color: $flavor-bounce-mango-passionfruit-accent;
        text-shadow:
        -2px -2px 0 #fff,  
         2px -2px 0 #fff,
         -2px 2px 0 #fff,
          2px 2px 0 #fff;
      }
      span {
        &:last-of-type {
          color: $flavor-bounce-mango-passionfruit;
        }
      }
      .slide-tagline {
        color: $bubly-bounce-blue;
      }
      .carousel-ctas {
        a {
          border-color: $bubly-bounce-blue;
          color: $bubly-bounce-blue;
        }
      }
      .brk-line {
        display: block;
      }
      @include breakpoint("laptop") {
        .brk-line {
          display: none;
        }
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/mango-passionfruit.png");

        // background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-bounce-mango-passionfruit;
      }
    }

    &--pineapple {
      background-color: $flavor-pineapple;
      span {
        color: $flavor-pineapple-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/pineapple.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-pineapple;
      }
    }

    &--watermelon {
      background-color: $flavor-watermelon;
      span {
        color: $flavor-watermelon-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/watermelon.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-watermelon;
      }
    }

    &--lime {
      background-color: $flavor-lime;
      span {
        color: $flavor-lime-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/lime.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-lime;
      }
    }
    &--grapefruit {
      background-color: $flavor-grapefruit;
      span {
        color: $flavor-grapefruit-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/grapefruit.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-grapefruit;
      }
    }
    &--orange {
      background-color: $flavor-orange;
      span {
        color: $flavor-orange-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/orange.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-orange;
      }
    }
    &--strawberry {
      background-color: $flavor-strawberry;
      span {
        color: $flavor-strawberry-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/strawberry.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-strawberry;
      }
    }
    &--mango {
      background-color: $flavor-mango;
      span {
        color: $flavor-mango-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/mango.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-mango;
      }
    }
    &--apple {
      background-color: $flavor-apple;
      span {
        color: $flavor-apple-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/apple.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-apple;
      }
    }
    &--cherry {
      background-color: $flavor-cherry;
      span {
        color: $flavor-cherry-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/cherry.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-cherry;
      }
    }
    &--lemon {
      background-color: $flavor-lemon;
      span {
        color: $flavor-lemon-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/lemon.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-lemon;
      }
    }
    &--blackberry {
      background-color: $flavor-blackberry;
      span {
        color: $flavor-blackberry-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/blackberry.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-blackberry;
      }
    }
    &--peach {
      background-color: $flavor-peach;
      span {
        color: $flavor-peach-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/peach.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-peach;
      }
    }
    &--raspberry {
      background-color: $flavor-raspberry;
      span {
        color: $flavor-raspberry-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/raspberry.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-raspberry;
      }
    }
    &--cranberry {
      background-color: $flavor-cranberry;
      span {
        color: $flavor-cranberry-accent;
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/cranberry.png");
        background-position: center bottom;
      }
      .carousel-ctas a:hover {
        color: $flavor-cranberry;
      }
    }
    &--orange-cream {
      background-color: $flavor-orange-cream;
      span {
        color: $flavor-orange-cream-can;

        &:first-child {
          color: $flavor-orange-cream-accent;
        }
      }
      .brk-line {
        display: block;
      }
      @include breakpoint("laptop") {
        .brk-line {
          display: none;
        }
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/orange-cream.png"), linear-gradient(180deg, #f6ed6c, #ff8200);
        background-repeat: repeat-x, no-repeat;
        background-size: auto 305px, cover;
        background-position: bottom, 50%;
      }
      .carousel-ctas a:hover {
        color: $flavor-orange-cream;
      }
    }

    &--bellini-bliss {
      background-color: $flavor-bellini-bliss;
      span {
        color: $flavor-bellini-bliss-can;

        &:first-child {
          color: $flavor-bellini-bliss-accent;
        }
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/bellini-bliss.png"), linear-gradient(180deg, #ff8097, #ffcf00);
        background-repeat: repeat-x, no-repeat;
        background-size: auto 305px, cover;
        background-position: bottom, 50%;
      }
      .carousel-ctas a:hover {
        color: $flavor-bellini-bliss;
      }
    }
    &--strawberry-sunset {
      background-color: $flavor-strawberry-sunset;
      span {
        color: $flavor-strawberry-sunset-can;

        &:first-child {
          color: $flavor-strawberry-sunset-accent;
        }
      }
      .brk-line {
        display: block;
      }
      @include breakpoint("laptop") {
        .brk-line {
          display: none;
        }
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/strawberry-sunset.png"), linear-gradient(180deg, #f6ed6c, #e10054);
        background-repeat: repeat-x, no-repeat;
        background-size: auto 305px, cover;
        background-position: bottom, 50%;
      }
      .carousel-ctas a:hover {
        color: $flavor-strawberry-sunset;
      }
    }

    &--blueberry-pomegranate {
      background-color: $flavor-blueberry-pomegranate;
      span {
        color: $flavor-blueberry-pomegranate-can;

        &:first-child {
          color: $flavor-blueberry-pomegranate-accent;
        }
      }
      .brk-line {
        display: inline;
      }
      @include breakpoint("desktop-large") {
        .brk-line {
          display: none;
        }
      }
      @include breakpoint("tablet") {
        background-image: url("./../assets/bubbles/blueberry-pomegranate.png"), linear-gradient(180deg, #30299a, #78258a);
        background-repeat: repeat-x, no-repeat;
        background-size: auto 305px, cover;
        background-position: bottom, 50%;
      }
      .carousel-ctas a:hover {
        color: $flavor-blueberry-pomegranate;
      }
    }
    
  }

  &-contents {
    display: inline-block;
  }

  &-text {
    position: absolute;
    top: 15px;
    width: 100%;
    z-index: 999;
  }

  &-title {
    font-size: 36px;
    color: #fff;
    font-weight: 600;
    margin-top: 10px;
  }

  &-tagline {
    list-style-type: none;
    margin: 20px 0 12px;
    padding: 0;
    font-size: 26px;
    color: #fff;
    font-weight: 600;

    li {
      text-align: center;
      margin: 5px 0;
    }
  }

  @include breakpoint("tablet") {
    .carousel-ctas {
      margin-top: 40px;
      padding: 0;

      a {
        float: left;
        width: auto;
        margin-left: 0;
        padding-left: 15px;
        padding-right: 15px;
      }
    }

    .slide {
      height: $carousel-height-tablet;

      &-contents {
        width: 100%;
        max-width: 1600px;
        margin: 0 auto;
        position: relative;
        height: $carousel-height-tablet;
      }

      &-text {
        width: calc(50% - 70px);
        display: inline-block;
        padding: 15px;
        box-sizing: border-box;
      }

      &-title {
        font-size: 42px;
        text-align: left;
        margin-top: 90px;
      }

      &-tagline {
        margin-top: 55px;
        font-size: 30px;

        li {
          text-align: left;
        }
      }

      &-image img {
        width: 300px;
        position: absolute;
        bottom: 0;
        left: 30%;
        transform: translateX(-50%);
      }
    }
  }

  @include breakpoint("desktop") {
    .carousel-ctas {
      margin-top: 40px;
    }

    .slide {
      &-title {
        font-size: 52px;
        margin-top: 68px;
      }

      &-tagline {
        font-size: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue